module.exports = __webpack_public_path__ + "media/images/lb/844-38ae7b0f20e715311740e42a8e7e09c0.svg";